
export default {
  authRealm: __REALM__,
  authUrl: __KEYCLOAK_AUTH__,
  authClientId: "intraweb",
  logoutRedirectUri: __LOGOUT_REDIRECT_URI__
}



// WEBPACK FOOTER //
// ./src/environment.js